export default "__VITE_ASSET__32e1d9a4__"